// Copyright © 2021 Move Closer
import { TokenType } from '@d24/demarked';
import { AbstractAdapter, getIdentifierConstraint, getRelatedTypeConstraint } from '../../../_abstract/adapter';
import { RelatedType } from '../../../../services';
import { ModuleDriver } from '../../../_contracts';
import { getModuleBase } from '../../../_helpers/adapter';
import { EmbedVersion } from '../../Embed.contracts';
export class EmbedVideoSwitchAdapter extends AbstractAdapter {
    objectToToken(object) {
        const { content } = object;
        this.validate(content, {
            description: {
                type: 'string'
            },
            video: {
                presence: false,
                type: 'object'
            },
            videoIdYoutube: {
                presence: false,
                type: 'string',
                length: { minimum: 1 }
            },
            videoIdOnHash: {
                presence: false,
                type: 'string',
                length: { minimum: 1 }
            },
            'video.type': getRelatedTypeConstraint(RelatedType.File, false),
            'video.value': getIdentifierConstraint(false)
        });
        if (typeof content.thumbnail !== 'undefined') {
            this.validate(content.thumbnail, {
                type: getRelatedTypeConstraint(RelatedType.File),
                value: getIdentifierConstraint()
            });
        }
        const { description, thumbnail, video, videoIdYoutube, videoIdOnHash } = content;
        const videoId = (video && video.value) ? video.value.toString() : undefined;
        if (!videoId && !videoIdYoutube && !videoIdOnHash) {
            throw new Error('one of [videoId, videoIdYoutube or videoIdOnHash] is required, but none was provided');
        }
        let meta = {};
        let raw = '#VIS[ ';
        const rawData = [];
        if (videoId) {
            rawData.push(`videoId: ${videoId}`);
        }
        if (videoIdYoutube) {
            rawData.push(`videoIdYoutube: ${videoIdYoutube}`);
        }
        if (videoIdOnHash) {
            rawData.push(`videoIdOnHash: ${videoIdOnHash}`);
        }
        if (typeof description === 'string' && description.length > 0) {
            meta = {
                ...meta,
                description
            };
            rawData.push(`description: ${description}`);
        }
        if (typeof thumbnail !== 'undefined' && typeof thumbnail.value === 'number') {
            const thumbnailId = thumbnail.value;
            if (typeof thumbnailId === 'number') {
                meta = {
                    ...meta,
                    thumbnailId
                };
                rawData.push(`thumbnailId: ${thumbnailId}`);
            }
        }
        raw += rawData.join(' | ');
        raw += ' ]';
        return {
            content: {
                videoId,
                videoIdYoutube,
                videoIdOnHash
            },
            raw,
            meta,
            type: TokenType.EmbedVideoSwitch
        };
    }
    tokenToObject(token) {
        this.validate(token, {
            'content.videoId': {
                presence: false,
                type: 'string',
                length: { minimum: 1 }
            },
            'content.videoIdYoutube': {
                presence: false,
                type: 'string',
                length: { minimum: 1 }
            },
            'content.videoIdOnHash': {
                presence: false,
                type: 'string',
                length: { minimum: 1 }
            }
        });
        if (typeof token.meta !== 'undefined') {
            this.validate(token.meta, {
                description: {
                    type: 'string'
                },
                thumbnailId: {
                    type: 'number'
                }
            });
        }
        const { content, meta } = token;
        const object = {
            ...getModuleBase(),
            content: {},
            driver: ModuleDriver.Embed,
            version: EmbedVersion.VideoSwitch
        };
        if (typeof content === 'object' && content.videoId) {
            object.content.video = {
                type: RelatedType.File,
                value: Number(content.videoId)
            };
        }
        if (typeof content === 'object' && content.videoIdOnHash) {
            object.content.videoIdOnHash = content.videoIdOnHash;
        }
        if (typeof content === 'object' && content.videoIdYoutube) {
            object.content.videoIdYoutube = content.videoIdYoutube;
        }
        if (typeof meta !== 'undefined') {
            const { description, thumbnailId } = meta;
            if (typeof description === 'string') {
                object.content.description = description;
            }
            if (typeof thumbnailId === 'number') {
                object.content.thumbnail = {
                    type: RelatedType.File,
                    value: thumbnailId
                };
            }
        }
        object.content.type = EmbedVersion.VideoSwitch;
        return object;
    }
}
